import { useQueries } from "@tanstack/react-query";
import { WarningIcon } from "@phosphor-icons/react";
import { fetchIndicators } from "../lib/api";

const OVERBOUGHT = 75;

// Seasoned meme-coin traders watch the 1m–5m RSI to avoid buying parabolic tops.
export const ParabolicTopWarning = ({ address }) => {
  const results = useQueries({
    queries: ["1m", "5m"].map((tf) => ({
      queryKey: ["indicators", address, tf],
      queryFn: () => fetchIndicators(address, tf),
      staleTime: 120000,
      refetchInterval: 60000,
    })),
  });

  const rsi1m = results[0].data?.rsi;
  const rsi5m = results[1].data?.rsi;
  const hot = [rsi1m, rsi5m].filter((v) => typeof v === "number" && v >= OVERBOUGHT);
  if (hot.length === 0) return null;

  const peak = Math.round(Math.max(...hot));
  return (
    <div data-testid="parabolic-top-warning" className="border border-danger/40 bg-danger/[0.08] p-4 flex items-start gap-3">
      <WarningIcon size={22} weight="fill" className="text-danger shrink-0 mt-0.5" />
      <div>
        <div className="font-heading font-bold text-sm text-danger">⚠ Parabolic top risk — overbought</div>
        <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
          Short-timeframe RSI is {peak}{" "}
          ({typeof rsi1m === "number" ? `1m ${Math.round(rsi1m)}` : "1m —"}
          {" · "}
          {typeof rsi5m === "number" ? `5m ${Math.round(rsi5m)}` : "5m —"}).
          Above {OVERBOUGHT} usually means a vertical run that's stretched — high odds of a sharp pullback. Chasing the top here is risky; consider waiting for a cooldown.
        </p>
      </div>
    </div>
  );
};
